export const useStyles = theme => ({
    fieldsContainer: {
        marginBottom: '60px',
    },
    requiredAsterisk: {
        color: '#009f3c',
    },
    lbLabel: {
        fontsize: '14px',
        color: '#263238',
        fontWeight: 'bold',
    },
    arrowIcon: {
        color: '#009F3C',
    },
    dialogPaper: {
        minWidth: '50vh',
    },
    radioLabel: {
        fontSize: '0.8em',
        "& svg": {
            width: '0.7em',
        }
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    nextButton: {
        boxShadow: 'none !important',
    },
    previousButton: {
        marginRight: '10px',
        boxShadow: 'none !important',
        border: '1px solid grey',
    },
    addButton: {
        boxShadow: 'none !important',
        border: '1px solid grey',
    },
    winnerField: {
        paddingLeft: '20px',
    },
});